import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from "../../shared/services/cart-service";
import { ApiService } from '../../shared/services/api.service';
import { RestaurantService } from '../../shared/services/restaurant.service';
import { EitCart } from '../../shared/classes/eitcart';
import { TypePayment, RESPONSE, AppInfo, DB } from '../../shared/services/env.service';
import { TypeOrder, StatusOrder, ET_TipoConsegna } from '../../shared/services/config-app';

@Component({
  selector: 'app-check',
  templateUrl: './check.component.html',
  styleUrls: ['./check.component.scss']
})
export class CheckComponent implements OnInit {

  numCheck: number = 0;
  interval: any;
  public cartData: any = {};
  public typeOrder: any = TypeOrder;
  public payType: any = TypePayment;
  orderStatus: any = StatusOrder;
  checkClosed: boolean = false;
  time_order: any = "12:00";
  day_order: any;
  //cartSub: Subscription; 
  tipoConsegna: any = ET_TipoConsegna;
  id_order: any = 0;
  public restFull: any = {};
  suggestions: Array<any> = []
  appInfo: any = AppInfo
  
  collapseOrder: boolean = false;
  collapseMultiMaster: boolean = false;
  collapseMultiSlaves: Array<boolean> = [];

  loadingTracking: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, public restService: RestaurantService,
    private cartService: CartService, private api: ApiService, private cdRef: ChangeDetectorRef) {
   
    this.cartData = new EitCart();

   // this.cartSub = new Subscription;

    this.id_order = 0;
    this.restFull = null;

    this.route.queryParams.subscribe(params => {
      if (params && params['order_id']) this.id_order = params['order_id'];
    });
   

   // this.cartSub.add(this.cartService.cartObs.subscribe(x => {

     // if (x) {
       // this.cartData = x;
        //localStorage.setItem("cart", JSON.stringify(this.cartData));
        //this.cartData.order.status = StatusOrder.REJECTED;
        
        //this.closeOrder();
     // }

    //}));

    this.restService.restaurant.subscribe(x => {
      if (x) {
        this.restFull = x;
      }
    });


  }

  ngOnInit(): void {

   // this.cartData = this.cartService.cart;
    //this.closeOrder();
    this.cartData = null;
    this.cartService.loadCartSingle(this.id_order).subscribe(data => {
      if (
        data[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK &&
        data[RESPONSE.JP_RESULT]
      ) {

        this.cartData = data[RESPONSE.JP_RESULT];
        
        if(this.cartData.order.slaves){
          this.cartData.order.slaves.forEach(() => {
            this.collapseMultiSlaves.push(false)
          });
        }
        this.fillSuggestions()

        this.closeOrder();

      }
      //this.loadingService.hide();
    }, (err) => {
      console.log(err);
      //this.loadingService.hide();
    })
  
  }

  fillSuggestions() {
    if(this.cartData){
      let excluded = [this.cartData.order.restaurant_id]
      if(this.cartData.order.slaves){
        this.cartData.order.slaves.forEach((slave: any) => {
          excluded.push(slave.rest_id)
        });
      }

      let data = {ids_excluded: excluded.join()}
      this.api.postj_T("restaurant/suggestions", data, "").subscribe(res => {
        if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
          this.suggestions = res[RESPONSE.JP_RESULT];
        }
      })
    }
  }

  goToRestaurant(rec: any){
    localStorage.setItem(DB.ACTIVITY_BASE, JSON.stringify(rec));
  }

  trackOrder(i?: number){
    if(this.cartData && this.cartData.order){
      this.loadingTracking = true;
      if(this.cartData.order.ismultiorder){
        if(i != null && i != undefined) {
          if(i > -1) {
            if(!this.collapseMultiSlaves[i]){
              this.api.postj_T("order/statustracking", {orderid: this.cartData.order.slaves[i].order_id}).subscribe(res => {
                if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
                  this.collapseMultiSlaves[i] = true;
                  this.cartData.order.slaves[i].status_tracking = res[RESPONSE.JP_RESULT]['status_tracking']
                  this.cartData.order.slaves[i].cc = res[RESPONSE.JP_RESULT]['cc']
                }
              })
            }
            else this.collapseMultiSlaves[i] = false;
          }
          else {
            if(!this.collapseMultiMaster){
              this.api.postj_T("order/statustracking", {orderid: this.cartData.order.id}).subscribe(res => {
                if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
                  this.collapseMultiMaster = true;
                  this.cartData.order.status_tracking = res[RESPONSE.JP_RESULT]['status_tracking']
                  this.cartData.order.cc = res[RESPONSE.JP_RESULT]['cc']
                }
              })         
            }     
            else this.collapseMultiMaster = false;
          }
        }
        else{
          if(!this.collapseMultiMaster){
            this.api.postj_T("order/statustracking", {orderid: this.cartData.order.id}).subscribe(res => {
              if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
                this.collapseMultiMaster = true;
                this.cartData.order.status_tracking = res[RESPONSE.JP_RESULT]['status_tracking']
                this.cartData.order.cc = res[RESPONSE.JP_RESULT]['cc']
                this.cartData.order.slaves.forEach((slave: any, index: number) => {
                  this.api.postj_T("order/statustracking", {orderid: slave.order_id}).subscribe(res => {
                    if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
                      slave.status_tracking = res[RESPONSE.JP_RESULT]['status_tracking']
                      slave.cc = res[RESPONSE.JP_RESULT]['cc']
                      if(index == this.cartData.order.slaves.length -1) {
                        this.loadingTracking = false;
                        for(let j = 0; j < this.collapseMultiSlaves.length; j++){
                          this.collapseMultiSlaves[j] = true;
                        }
                      }
                    }
                  })              
                });
              }            
            })
          }
          else {
            this.collapseMultiMaster = false;
            for(let j = 0; j < this.collapseMultiSlaves.length; j++){
              this.collapseMultiSlaves[j] = false;
            }
          }
        }
      }
      else {
        if(!this.collapseOrder){
          this.api.postj_T("order/statustracking", {orderid: this.cartData.order.id}).subscribe(res => {
            if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
              this.collapseOrder = true;
              this.cartData.order.status_tracking = res[RESPONSE.JP_RESULT]['status_tracking']
              this.cartData.order.cc = res[RESPONSE.JP_RESULT]['cc']
            }
          })  
        }  
        else this.collapseOrder = false;
      }
    }
  }

  initCheck() {
    this.cartData.order.status = this.orderStatus.PAID;
    this.interval = setInterval(() => {
      this.checkOrder();
    }, 3000);

    setTimeout(() => { this.autoClose(); }, 30000); // Skeleton Loader
  }

  autoClose()
  {
    var data = { orderid: this.cartData.order_id };
    this.api.postj_T("order/autoclose", data, "");
  }
 
  checkOrder() {
    this.numCheck++;
    var data = { orderid: this.cartData.order_id };
    this.api.postj_T("order/recordpreaccepted", data, "").subscribe(
      res => {
        if (
          res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK &&
          res[RESPONSE.JP_RESULT]
        ) {
          this.cartData.order.delivery_time =
            res[RESPONSE.JP_RESULT]["delivery_time"];
          this.cartData.order.real_delivery_time =
            res[RESPONSE.JP_RESULT]["real_delivery_time"];
          this.cartData.order.data_ordine_dmy =
            res[RESPONSE.JP_RESULT]["data_ordine_dmy"];
          this.cartData.order.status = res[RESPONSE.JP_RESULT]["status"];
          this.cartData.order.tipooraconsegna =
            res[RESPONSE.JP_RESULT]["tipooraconsegna"];
          this.cartData.order.fasciaoraria =
            res[RESPONSE.JP_RESULT]["fasciaoraria"];
          this.cartData.order.bookingdate =
            res[RESPONSE.JP_RESULT]["bookingdate"];
          this.cartData.order.tipomodoconsegna =
            res[RESPONSE.JP_RESULT]["tipomodoconsegna"];
          this.cartData.order.order_date =
            res[RESPONSE.JP_RESULT]["order_date"];
          this.cartData.order.consegna_eit =
            res[RESPONSE.JP_RESULT]["consegna_eit"];
          this.cdRef.detectChanges();
          this.validateOrder();
        } else {
          console.log(this.numCheck);
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  validateOrder() {
    if (this.cartData.order.status != StatusOrder.PAID) {
      clearInterval(this.interval);
      this.checkClosed = true;
      if (this.cartData.order.status == StatusOrder.ACCEPTED) {
        this.cartData.order.status = StatusOrder.ACCEPTED_NOTIFIED;
      } else if (this.cartData.order.status == StatusOrder.REJECTED) {
        this.cartData.order.status = StatusOrder.REJECTED_NOTIFIED;
      } else if (this.cartData.order.status == StatusOrder.NO_RESPONSE) {
        this.cartData.order.status = StatusOrder.NO_RESPONSE_NOTIFIED;
      }
      var data = {
        orderid: this.cartData.order_id,
        status: this.cartData.order.status,
        delivery_time: this.cartData.order.delivery_time
      };

      this.api.postj_T("order/status", data, "").subscribe(
        res => {
          if (
            res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK &&
            res[RESPONSE.JP_RESULT]
          ) {
            console.log("Validation order OK");
            this.time_order = res[RESPONSE.JP_RESULT]["order_time"];
            this.day_order = res[RESPONSE.JP_RESULT]['day_order'];
            // this.cartData.order.type_order = 3
            // this.cartService.loadCart(this.cartData.order_id)
            this.cartService.loadCartSingle(this.id_order).subscribe(data => {
              if (data[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && data[RESPONSE.JP_RESULT]) {        
                this.cartData = data[RESPONSE.JP_RESULT];                
                if(this.cartData.order.slaves){
                  this.cartData.order.slaves.forEach(() => {
                    this.collapseMultiSlaves.push(false)
                  });
                }   
                this.cdRef.detectChanges();     
              }
              //this.loadingService.hide();
            }, (err) => {
              console.log(err);
              //this.loadingService.hide();
            })
          } else {
            console.log(this.numCheck);
          }
        },
        err => {
          console.log(err);
        }
      );
    }
    if (this.numCheck >= 45 && !this.checkClosed) {
      clearInterval(this.interval);
      this.cartData.order.status = StatusOrder.NO_RESPONSE_NOTIFIED;
      this.cartData.order.delivery_time = -1;
    }
  }

  reactivateorder() {
    var data = { pid: this.cartData.order_id };
    this.api.postj("order/rreactivateorder", data, "").subscribe(
      res => {
        if (
          res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK &&
          res[RESPONSE.JP_RESULT]
        ) {
          //deve ricominciare ad aspettare una risposta
          //  $window.location.href = SysUtils.Path + '/check?pid=' + pid + '&device=1';
        } else {
          console.log(this.numCheck);
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  /*trackOrder() {
    this.navCtrl.push(TrackingPage, { order: this.cartData.order });
  }*/

  closeOrder() {
    //this.cartSub.unsubscribe();
    this.cartService.closeOrder();
    this.initCheck();
  }


  goToHome()
  {
    this.router.navigate(['/'], { queryParams: { } });
  }

  orderCompleted(){
    let status = this.cartData.order.status;
    if(status === StatusOrder.CREATED && this.cartData.order.ismultiorder){
      for(let i = 0; i < this.cartData.order.slaves.length; i++){
        if(this.cartData.order.slaves[i].status > StatusOrder.CREATED){
          status = this.cartData.order.slaves[i].status;
          break;
        }
      }
    }
    return status == StatusOrder.ACCEPTED_NOTIFIED || status == StatusOrder.ACCEPTED || 
           status == StatusOrder.PREORDERED || status == StatusOrder.PREACCEPTED || 
           status == StatusOrder.NO_RESPONSE || status == StatusOrder.NO_RESPONSE_NOTIFIED
  }

  getShortTitle(){
    let status = this.cartData.order.status;
    if(status === StatusOrder.CREATED && this.cartData.order.ismultiorder){
      for(let i = 0; i < this.cartData.order.slaves.length; i++){
        if(this.cartData.order.slaves[i].status > StatusOrder.CREATED){
          status = this.cartData.order.slaves[i].status;
          break;
        }
      }
    }

    switch(status){
      case StatusOrder.PAID: return "Ordine in attesa di conferma";
      case StatusOrder.ACCEPTED_NOTIFIED: 
      case StatusOrder.ACCEPTED: 
      case StatusOrder.NO_RESPONSE: 
      case StatusOrder.NO_RESPONSE_NOTIFIED: 
      case StatusOrder.PREACCEPTED: 
      case StatusOrder.PREORDERED: 
        return "Ordine confermato";
      case StatusOrder.REJECTED: 
      case StatusOrder.REJECTED_NOTIFIED: 
        return "Ordine in attesa di conferma";
    }
  }

  getTitle(){
    let status = this.cartData.order.status;
    if(status === StatusOrder.CREATED && this.cartData.order.ismultiorder){
      for(let i = 0; i < this.cartData.order.slaves.length; i++){
        if(this.cartData.order.slaves[i].status > StatusOrder.CREATED){
          status = this.cartData.order.slaves[i].status;
          break;
        }
      }
    }

    switch(status){
      case StatusOrder.PAID: return "Il tuo ordine <br>è stato <br>inviato!";
      case StatusOrder.ACCEPTED_NOTIFIED: 
      case StatusOrder.ACCEPTED: 
      case StatusOrder.NO_RESPONSE: 
      case StatusOrder.NO_RESPONSE_NOTIFIED: 
      case StatusOrder.PREACCEPTED: 
      case StatusOrder.PREORDERED: 
        return "Il tuo ordine<br>è confermato";
      case StatusOrder.REJECTED: 
      case StatusOrder.REJECTED_NOTIFIED: 
        return "Il tuo ordine <br>è in attesa<br> di conferma!";
    }
  }

  getSubTitle(){
    let status = this.cartData.order.status;
    if(status === StatusOrder.CREATED && this.cartData.order.ismultiorder){
      for(let i = 0; i < this.cartData.order.slaves.length; i++){
        if(this.cartData.order.slaves[i].status > StatusOrder.CREATED){
          status = this.cartData.order.slaves[i].status;
          break;
        }
      }
    }

    switch(status){
      case StatusOrder.PAID: return "Attendi che lo chef accetti l'ordine.<br /> <strong>NON</strong> aggiornare la pagina e <strong>NON</strong> tornare indietro alla pagina precedente.";
      case StatusOrder.ACCEPTED_NOTIFIED: 
      case StatusOrder.ACCEPTED: 
      case StatusOrder.NO_RESPONSE: 
      case StatusOrder.NO_RESPONSE_NOTIFIED: 
      case StatusOrder.PREACCEPTED: 
      case StatusOrder.PREORDERED: 
        return "Riceverai un SMS<br>per monitorare lo stato<br>del tuo ordine";
      case StatusOrder.REJECTED: 
      case StatusOrder.REJECTED_NOTIFIED: 
        return "";
    }
  }

}
